import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import FORM_INPUT_CLASS from './formInputClass'

const CommentMarkField = ({ mark, readonly, onChange }) => {
  const handleChange = useCallback(event => onChange({ value: event.target.value }), [onChange])

  return (
    <textarea
      className={`${FORM_INPUT_CLASS} tw:lg:w-1/2!`}
      disabled={readonly}
      placeholder="Ajouter un commentaire..."
      rows={3}
      value={mark.value || ''}
      onChange={handleChange}
    />
  )
}

CommentMarkField.propTypes = {
  mark: PropTypes.shape({ value: PropTypes.string }).isRequired,
  onChange: PropTypes.func.isRequired,
  readonly: PropTypes.bool
}

CommentMarkField.defaultProps = {
  readonly: false
}

export default CommentMarkField
